import React from "react";

import { createAvatarName } from "../../../../../utils";
import Avatar from "../../../../../components/Avatar";

function MissingStatusUser({ params }) {
  return (
    <>
      <div className="d-flex align-items-center" >
        <div className="cursor-pointer">
          <Avatar
            username={params?.row?.username}
            user_image={params?.row?.user_image}
            title={params?.row?.username}
            className="user-avtar-dropdown user-avatar  mr-2"
            style={
              !params.row.user_image && {
                bgcolor: params?.row?.profile_color?.background,
                color: params?.row?.profile_color?.text,
              }
            }
          >
            {createAvatarName(params?.row?.username)}
          </Avatar>
        </div>
        <p>{params?.row?.username}</p>
      </div>
    </>
  );
}

const isChangeMissingStatusUser = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.username === nextProps?.params?.row?.username
    && prevProps?.params?.row?.user_image === nextProps?.params?.row?.user_image
    && prevProps?.params?.row?.profile_color?.text === nextProps?.params?.row?.profile_color?.text
    && prevProps?.params?.row?.profile_color?.background === nextProps?.params?.row?.profile_color?.background
  );
};

export default React.memo(MissingStatusUser, isChangeMissingStatusUser);
